import { render } from "./ListeTypeConsultation.vue?vue&type=template&id=4555e272&scoped=true"
import script from "./ListeTypeConsultation.vue?vue&type=script&lang=js"
export * from "./ListeTypeConsultation.vue?vue&type=script&lang=js"

import "./ListeTypeConsultation.vue?vue&type=style&index=0&id=4555e272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4555e272"]])

export default __exports__